import { Subscription } from 'rxjs';
import { ButtonType } from './enums/button-type.enum';
import { InputType } from './enums/input-type.enum';

export class BaseController {
    ButtonType = ButtonType;
    InputTypes = InputType;
    private subscriptions: Subscription[] = [];

    addSubscription(subscription: Subscription): void {
        this.subscriptions.push(subscription);
    }

    addSubscriptions(subscriptions: Subscription[]): void {
        this.subscriptions = this.subscriptions.concat(subscriptions);
    }

    _ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
